<script setup lang="ts">
defineProps({
  containerWidth: null,
  containerHeight: null
})

// For historical reasons, the svg flap was set to 145:192, corresponding
// to 75% of the height of the container.
const maxDimensions = Math.max(__props.containerWidth, __props.containerHeight) * 0.75
</script>

<template>
  <svg
    viewBox="0 0 145 145"
    :style="{
      'max-width': px(maxDimensions),
      'max-height': px(maxDimensions),
    }"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_14324_49074)">
      <g filter="url(#filter0_dd_14324_49074)">
        <path
          d="M96.493 10.2458C95.804 9.57408 88.3951 2.82264 83.4144 0.997782C83.1241 0.889898 82.426 0.642011 81.956 0.51353C81.4859 0.385049 80.4561 0.117643 80 0H145.088V59.4862C145.09 59.4933 145.09 59.4976 145.088 59.5009V59.4862C145.08 59.4372 145.001 59.2564 144.705 58.3644C144.419 57.5049 143.858 56.3739 143.609 55.9167C141.797 52.7451 137.468 48.0087 136.838 47.3705C136.787 47.3187 136.737 47.271 136.684 47.2217L96.6221 10.3682C96.5774 10.3271 96.5365 10.2882 96.493 10.2458Z"
          fill="#EEEEEE"
        />
      </g>
      <path
        d="M138.398 24.9348C136.307 22.778 130.596 23.6568 129.228 23.8165C127.217 21.8992 125.85 19.5826 125.367 18.7839C126.091 16.627 126.574 14.4702 126.654 12.1538C126.654 10.1567 125.85 8 123.597 8C122.793 8 122.069 8.47914 121.667 9.11818C120.702 10.7959 121.104 14.1509 122.632 17.5859C121.747 20.0621 120.943 22.4585 118.691 26.6924C116.358 27.6507 111.451 29.8876 111.049 32.2841C110.888 33.0029 111.129 33.7221 111.692 34.2811C112.255 34.7604 112.979 35 113.703 35C116.68 35 119.575 30.9262 121.586 27.491C123.276 26.932 125.93 26.133 128.585 25.6537C131.722 28.3697 134.457 28.769 135.905 28.769C137.835 28.769 138.559 27.9703 138.8 27.2512C139.202 26.4526 138.961 25.5739 138.398 24.9348ZM136.387 26.2929C136.307 26.8521 135.583 27.4111 134.296 27.0917C132.767 26.6924 131.4 25.9733 130.193 25.0147C131.239 24.8548 133.572 24.6152 135.261 24.9348C135.905 25.0945 136.548 25.494 136.387 26.2929ZM122.954 9.83707C123.115 9.5975 123.356 9.43778 123.597 9.43778C124.321 9.43778 124.482 10.3164 124.482 11.0355C124.402 12.7132 124.08 14.3905 123.517 15.9882C122.31 12.7928 122.552 10.556 122.954 9.83707ZM122.793 25.3343C123.437 24.0562 124.322 21.8193 124.643 20.8607C125.367 22.0587 126.574 23.4969 127.217 24.1359C127.217 24.2159 124.724 24.6951 122.793 25.3343ZM118.047 28.5296C116.197 31.5651 114.267 33.4822 113.221 33.4822C113.06 33.4822 112.899 33.4023 112.738 33.3225C112.497 33.1626 112.416 32.923 112.497 32.6036C112.738 31.4852 114.83 29.9674 118.047 28.5296Z"
        fill="#3E3D41"
        style="fill:#3E3D41;fill:color(display-p3 0.2431 0.2392 0.2549);fill-opacity:1;"
      />
      <g filter="url(#filter1_ddi_14324_49074)">
        <path
          d="M83.4146 0.996094C83.4146 0.996094 83.4686 1.00009 83.5639 1.05202C88.542 2.95472 95.811 9.57908 96.4932 10.2441C96.5367 10.2865 96.5776 10.3254 96.6223 10.3665L136.684 47.22C136.738 47.2693 136.787 47.317 136.839 47.3688C137.464 48.0025 141.737 52.6778 143.571 55.8487C143.603 55.8918 143.609 55.915 143.609 55.915C143.596 55.893 143.584 55.8709 143.571 55.8487C143.31 55.5032 141.325 53.8808 126.702 52.724C116.598 51.9248 101.083 51.5605 93.2701 51.7638C92.8216 51.7754 92.3604 51.8035 91.8994 51.843C89.4395 52.0537 87.1337 49.6864 87.2433 47.22C87.6858 37.258 87.6775 37.5511 87.2433 22.1238C86.7313 3.93302 84.2072 1.40228 83.5639 1.05202C83.5139 1.0329 83.4641 1.01425 83.4146 0.996094Z"
          fill="url(#paint0_linear_14324_49074)"
          style=""
        />
        <path
          d="M83.4146 0.996094C83.4146 0.996094 83.4686 1.00009 83.5639 1.05202C88.542 2.95472 95.811 9.57908 96.4932 10.2441C96.5367 10.2865 96.5776 10.3254 96.6223 10.3665L136.684 47.22C136.738 47.2693 136.787 47.317 136.839 47.3688C137.464 48.0025 141.737 52.6778 143.571 55.8487C143.603 55.8918 143.609 55.915 143.609 55.915C143.596 55.893 143.584 55.8709 143.571 55.8487C143.31 55.5032 141.325 53.8808 126.702 52.724C116.598 51.9248 101.083 51.5605 93.2701 51.7638C92.8216 51.7754 92.3604 51.8035 91.8994 51.843C89.4395 52.0537 87.1337 49.6864 87.2433 47.22C87.6858 37.258 87.6775 37.5511 87.2433 22.1238C86.7313 3.93302 84.2072 1.40228 83.5639 1.05202C83.5139 1.0329 83.4641 1.01425 83.4146 0.996094Z"
          fill="url(#paint1_linear_14324_49074)"
          style=""
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dd_14324_49074"
        x="62.9873"
        y="-9.46228"
        width="108.836"
        height="88.6646"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="12.1519" dy="5.12" />
        <feGaussianBlur stdDeviation="7.29114" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0823529 0 0 0 0 0.0862745 0 0 0 0 0.105882 0 0 0 0.3 0" />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_14324_49074"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2.43038" dy="5.12" />
        <feGaussianBlur stdDeviation="7.29114" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0823529 0 0 0 0 0.0862745 0 0 0 0 0.105882 0 0 0 0.3 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_14324_49074"
          result="effect2_dropShadow_14324_49074"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_14324_49074"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_ddi_14324_49074"
        x="66.4019"
        y="-11.4662"
        width="103.941"
        height="87.0825"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="12.1519" dy="5.12" />
        <feGaussianBlur stdDeviation="7.29114" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0823529 0 0 0 0 0.0862745 0 0 0 0 0.105882 0 0 0 0.2 0" />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_14324_49074"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2.43038" dy="2.12" />
        <feGaussianBlur stdDeviation="7.29114" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0823529 0 0 0 0 0.0862745 0 0 0 0 0.105882 0 0 0 0.2 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_14324_49074"
          result="effect2_dropShadow_14324_49074"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_14324_49074"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-4" dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect3_innerShadow_14324_49074"
        />
      </filter>
      <linearGradient
        id="paint0_linear_14324_49074"
        x1="103.309"
        y1="13.9487"
        x2="91.2661"
        y2="40.2297"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F6F6F6" style="stop-color:#F6F6F6;stop-color:color(display-p3 0.9647 0.9647 0.9647);stop-opacity:1;" />
        <stop
          offset="0.35"
          stop-color="#F6F6F6"
          style="stop-color:#F6F6F6;stop-color:color(display-p3 0.9655 0.9655 0.9655);stop-opacity:1;"
        />
        <stop
          offset="0.5"
          stop-color="white"
          style="stop-color:white;stop-opacity:1;"
        />
        <stop
          offset="0.65"
          stop-color="#FEFEFE"
          style="stop-color:#FEFEFE;stop-color:color(display-p3 0.9980 0.9980 0.9980);stop-opacity:1;"
        />
        <stop
          offset="1"
          stop-color="#F6F6F6"
          style="stop-color:#F6F6F6;stop-color:color(display-p3 0.9647 0.9647 0.9647);stop-opacity:1;"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_14324_49074"
        x1="81.1003"
        y1="42.6126"
        x2="139.125"
        y2="49.6765"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#BDBDBD"
          stop-opacity="0"
          style="stop-color:none;stop-opacity:0;"
        />
        <stop
          offset="1"
          stop-color="white"
          style="stop-color:white;stop-opacity:1;"
        />
      </linearGradient>
      <clipPath id="clip0_14324_49074">
        <rect
          width="145"
          height="192"
          fill="white"
          style="fill:white;fill-opacity:1;"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

svg
  @apply absolute
  .extension
    fill: $global-t-tertiary
    @apply font-mono font-bold tracking-wide
</style>
